import { render } from "./ModalSottoProgetto.vue?vue&type=template&id=1c86d725&ts=true"
import script from "./ModalSottoProgetto.vue?vue&type=script&lang=ts"
export * from "./ModalSottoProgetto.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__